export const BASE = {
  name: 'survey-templates',
  path: '/sites/:siteId/survey-templates',
};

export const AI_QUESTIONS = {
  name: 'survey-templates',
  path: '/sites/:siteId/survey-templates/ai',
};
